import styled from 'styled-components';
import { fontFamily, fontSize, fontWeight, primaryColor, secondaryColor, warningColor } from '@styles/utils';

export const MessageContainer = styled.p<{ type: 'error' | 'success' }>`
  padding: 10px 20px;
  margin-bottom: 10px;
  font-family: ${fontFamily};
  font-size: ${fontSize.standard};
  font-weight: ${fontWeight.bold};
  line-height: 1.79;
  border: 2px solid ${props => (props.type === 'error' ? secondaryColor(700) : primaryColor())};
  color: ${props => (props.type === 'error' ? secondaryColor(700) : primaryColor())};
`;

export const ErrorMessageContainer = styled.div`
  padding: 10px 20px;
  margin-bottom: 20px;
  font-family: ${fontFamily};
  ${fontSize.standard};
  font-weight: ${fontWeight.bold};
  line-height: 1.79;
  border: 2px solid ${warningColor};
  background-color: rgba(248, 121, 121, 0.15);
  color: ${warningColor};

  a {
    ${fontSize.standard};
    font-weight: ${fontWeight.bold};
    color: ${warningColor};
  }
`;

export const SuccessMessageContainer = styled(ErrorMessageContainer)`
  border: 2px solid ${primaryColor(300)};
  background-color: rgba(91, 176, 142, 0.15);
  color: ${primaryColor(300)};
`;
